import React, {useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Cookies from 'universal-cookie';
import {useAuth} from "../utils/useAuth";


const ImportLook = (props) => {
    const [looks, setLooks] = useState([]);
    const [products, setProducts] = useState([]);
    const [importing, setImporting] = useState(false);
    const { getAccessToken } = useAuth();


    React.useEffect(() => {
        //parseCsv()
    }, [])

    /*
    function parseCsv() {
        var looks = []
        var producs = []

        Papa.parse('https://showroom.globalbit.gucci/NOTDeletethisFolder/look.csv', {
            header: true,
            delimiter: ",",
            download: true,
            dynamicTyping: true,
            complete: function (results) {

                if (results.errors != null) {
                    //console.log("some errors while parsing csv", results.errors)
                }
                if (results.data != null) {
                    //console.log("csv successfully parsed", results.data)

                    results.data.forEach(row => {

                        if (row.LOOK != null && row.SMC != null) {
                            producs.push(row)

                            if (!looks.some(e => e.LOOK === row.LOOK)) {
                                looks.push(row)
                            }

                        } else {
                            // console.log("empty row")
                        }
                    })
                    setLooks(looks)
                    setProducts(producs)
                }
            }
        });


    }
*/


    const importProducts = async (look) => {
        try {
            setImporting(true);

            const accessToken = await getAccessToken();
            if (!accessToken) throw new Error("Not authenticated");

            const cookies = new Cookies();
            const hashCode = cookies.get("hashCode") || "";

            const res = products.filter((item) => item.LOOK === look);

            await Promise.all(
                res.map(async (row) => {
                    const formattedSMC =
                        row.SMC.slice(0, 6) + "-" + row.SMC.slice(6, 11) + "-" + row.SMC.slice(11, 15);
                    const imgLink = "http://getimage.emea.guccigroup.dom/getimage/?Cod=" + formattedSMC;

                    const newItem = {
                        id: generateUniqSerial(),
                        name: "N/A",
                        hotspostID: props.hotspot.id,
                        sku: "N/A",
                        smc: row.SMC,
                        imageLink: imgLink,
                        timestamp: Math.floor(Date.now() / 1000).toString(),
                        createdBy: "",
                        visibilityColorWeb: true,
                        visibilityBrandExperience: true,
                        position: "",
                    };

                    const headers = {
                        Authorization: accessToken + hashCode,
                        "Content-Type": "application/json",
                    };

                    const requestOptions = {
                        method: "POST",
                        headers,
                        body: JSON.stringify(newItem),
                    };

                    const response = await fetch(
                        process.env.REACT_APP_API_ENDPOINT + "products",
                        requestOptions
                    );
                    if (!response.ok) throw new Error(`HTTP ${response.status}`);
                    return await response.json();
                })
            );

            setImporting(false);
            props.setOpenDialogImportLook(false);

            if (props.fetchDisplays) {
                props.fetchDisplays();
            }
        } catch (err) {
            console.error("importProducts error:", err);
            setImporting(false);
        }
    };

    const handleImportLook = async (look) => {
        await importProducts(look);
    };


    function generateUniqSerial() {
        return 'xxxx-xxxx-xxx-xxxx'.replace(/[x]/g, (c) => {
            const r = Math.floor(Math.random() * 16);
            return r.toString(16);
        });
    }


    return (
        <Dialog open={props.openDialogImportLook} onClose={() => props.setOpenDialogImportLook(false)} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Import a Look</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Import a Look in the Hotspot named: {props.hotspot.name}
                </DialogContentText>

                {importing ? <CircularProgress /> :

                    looks.map((item) => (
                        <ListItem onClick={() => handleImportLook(item.LOOK)} title={item.LOOK} button>
                            <ListItemText primary={item.LOOK} />
                        </ListItem>
                    ))

                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.setOpenDialogImportLook(false)} className="red template_button">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>

    );
};

export default ImportLook
